function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, InputNumber, Modal, Image, Alert, Descriptions, Row as AntRow, Col as AntCol } from "antd";
import Common from "../includes/Common";
import moment from "moment";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var AddExistingAttendantSession = function AddExistingAttendantSession(_ref) {
  var handler = _ref.handler,
    attender = _ref.attender;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    sessions = _useState2[0],
    setSessions = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormProcessing = _useState8[0],
    setIsFormProcessing = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    currentAttendant = _useState0[0],
    setCurrentAttendant = _useState0[1];
  var _useState1 = useState(),
    _useState10 = _slicedToArray(_useState1, 2),
    currentSession = _useState10[0],
    setCurrentSession = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    ra = _useState12[0],
    setRa = _useState12[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setErrorMessage("");
    setSuccessMessage("");
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'ajout du participant ", values.name, " ainsi que la reception de ", values.paid_amount.toLocaleString("Fr"), " GNF pour la formation ", sessions.filter(function (s) {
          return s.id == values.learnning_session_id;
        })[0].label]
      }),
      onOk: function onOk() {
        registrate(values);
      }
    });
  };
  var registrate = function registrate(values) {
    var fData = new FormData();
    fData.append("learning_session_id", values.learning_session_id);
    fData.append("attendant_id", attender.id.toString());
    fData.append("paid_amount", values.paid_amount);
    fData.append("user_id", Common.currentUser.id);
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + "addexistingattendersession", fData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        setCurrentAttendant(response.data.attendant);
        setCurrentSession(response.data.session);
        setRa(values.paid_amount);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        handler();
        form.setFieldsValue({
          name: "",
          email: "",
          mobile: "",
          paid_amount: ""
        });
        var content = document.getElementById("prtdiv");
        var pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write(content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    axios.all([axios.get(Common.baseApiUrl + "getupcomingsessions/" + Common.currentUser.id), axios.get(Common.baseApiUrl + "getcurrentsessions/" + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status == 200) response[0].data.sessions.forEach(function (s) {
        setSessions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            value: s.id,
            label: "".concat(s.label, " (").concat(s.price.toLocaleString('Fr'), " GNF - DU ").concat(moment(s.start_date).format("DD/MM"), " AU ").concat(moment(s.end_date).format("DD/MM"), ")")
          }]);
        });
      });
      if (response[1].data.status == 200) response[1].data.sessions.forEach(function (s) {
        setSessions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            value: s.id,
            label: "".concat(s.label, " (").concat(s.price.toLocaleString('Fr'), " GNF - DU ").concat(moment(s.start_date).format("DD/MM"), " AU ").concat(moment(s.end_date).format("DD/MM"), ")")
          }]);
        });
      });
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue pendant le chargement");
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [currentSession != null && currentAttendant != null && /*#__PURE__*/_jsx("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: /*#__PURE__*/_jsx(SessionPaymentReceipt, {
        session: currentSession,
        attender: currentAttendant,
        due: due,
        transaction: currentTransaction
      })
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsx("div", {
      style: {
        background: "#FFDE59",
        padding: "10px",
        borderRadius: "4px"
      },
      children: /*#__PURE__*/_jsxs(Descriptions, {
        title: /*#__PURE__*/_jsx("b", {
          children: "INFOS PARTICIPANTS"
        }),
        column: 1,
        children: [/*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "NOM"
          }),
          children: attender.name
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "TELEPHONE"
          }),
          children: attender.mobile
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      onFinish: onFinish,
      layout: "vertical",
      form: form,
      children: [(errorMessage.length > 0 || successMessage.length > 0) && /*#__PURE__*/_jsxs(Form.Item, {
        children: [successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          banner: true
        }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Session de Formation",
        name: "learning_session_id",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          placeholder: "Choisir une session",
          options: sessions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "paid_amount",
        label: "Montant pay\xE9",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          size: "large",
          addonAfter: "GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "ENREGISTRER"
          })
        })
      })]
    })]
  });
};
export default AddExistingAttendantSession;